export default __webpack_public_path__ + "static/media/gallery_09.e3563bc4.jpg";